import { setDataForApi } from "utils/api";
import { FormSchemaProperty } from "./types";

const parseDataForApi = (
  data: FormSchemaProperty & {
    avmValuation?: number;
    avmConfidenceLevel?: string;
  },
) => {
  const _data = { ...data };

  if (_data.avmValuation) {
    delete _data.avmValuation;
  }

  if (_data.avmConfidenceLevel) {
    delete _data.avmConfidenceLevel;
  }

  setDataForApi(_data);
  return _data;
};

export default parseDataForApi;
